(function () {
  window.addEventListener("gift.hero:initalized", function () {
    var GiftHeroAPI = window.GiftHeroAPI;
    var formElement = document.querySelector(
      ".main-product-gift-card .product-details-wrapper"
    );
    var dateField = document.querySelector(".input-date");
    if (dateField) {
      var picker = new Pikaday({ field: dateField, minDate: new Date() });
    }
    formElement.style.visibility = "visible";
    var variantSelector = document.querySelector("variant-selects select");
    var gallery = document.querySelector(".gc-gallery");
    var previewBtn = document.querySelector(".preview-link a");
    var handleVariantChange = function () {
      var variantId = /\d+/.exec(
        window.location.search.split("variant=")?.[1]
      )?.[0];
      GiftHeroAPI.setVariant(variantId);
    };
    variantSelector.addEventListener("change", handleVariantChange);

    var capitalizeFirstLetter = function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    var removeClass = function (selector, classToRemove) {
      var elements = document.querySelectorAll(selector);
      for (var i = 0; i < elements.length; i++) {
        elements[i].classList.remove(classToRemove);
      }
    };

    var createGalleryElement = function (image, selected) {
      if (gallery) {
        var element = document.createElement("div");
        element.classList.add("gallery-item");
        if (selected) element.classList.add("gallery-item--selected");
        element.innerHTML = "<img src=" + image + " />";
        element.addEventListener("click", function (e) {
          removeClass(".gallery-item", "gallery-item--selected");
          e.currentTarget.classList.add("gallery-item--selected");
          GiftHeroAPI.setImage(image);
        });
        gallery.appendChild(element);
      }
    };

    if (gallery) {
      var images = GiftHeroAPI.getImages();
      if (images && images.length > 1) {
        for (var i = 0; i < images.length; i++) {
          createGalleryElement(images[i], i === 0);
        }
      }
    }

    if (previewBtn) {
      previewBtn.addEventListener("click", function (e) {
        e.preventDefault();
        GiftHeroAPI.generatePreview();
      });
    }

    var getLabel = function (element) {
      var label = element.parentElement.querySelector("label");
      if (label) {
        return capitalizeFirstLetter(label.innerText.replace("Enter ", ""));
      }
      return null;
    };

    var validateEmail = function (email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    var validatePhone = function (phone) {
      return String(phone)
        .toLowerCase()
        .match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
    };

    var validateField = function (field) {
      var value = field.value;
      var name = field.name;
      var errorElement = field.parentElement.querySelector(".error-text");
      var required = field.required;
      var valid = true;
      if (errorElement) {
        if (
          (!value && required) ||
          (name === "recipient_email" && !validateEmail(value)) ||
          (name === "recipient_number" && !validatePhone(value))
        ) {
          errorElement.style.visibility = "visible";
          valid = false;
        } else if (
          (value && required) ||
          (name === "recipient_email" && validateEmail(value)) ||
          (name === "recipient_number" && validatePhone(value))
        ) {
          errorElement.style.visibility = "hidden";
          valid = true;
        }
      }
      return valid;
    };

    var handleInputChange = function (e) {
      var value = e.target.value;
      var name = e.target.name;

      validateField(e.target);

      switch (name) {
        case "recipient_name": {
          GiftHeroAPI.setTo(value + ",");
          break;
        }
        case "recipient_email": {
          GiftHeroAPI.setEmail(value);
          break;
        }
        case "message": {
          GiftHeroAPI.setMessage(value);
          break;
        }
        case "sender_name": {
          GiftHeroAPI.setFrom(value);
          break;
        }
        case "properties[Delivery Date]": {
          var date = new Date(value);
          date.setHours(12);
          GiftHeroAPI.setDeliveryDate(date);
          break;
        }
        default: {
          var label = getLabel(e.target);
          GiftHeroAPI.setProperty(label, value);
        }
      }
    };

    var toggleInputFocus = function (state) {
      return function (e) {
        if (state === "focus") {
          e.target.parentElement.classList.add("new-form-control--focus");
        } else if (!e.target.value) {
          e.target.parentElement.classList.remove("new-form-control--focus");
        }
      };
    };

    var fields = document.querySelectorAll(
      ".product-details-wrapper .new-form-control input, .product-details-wrapper .new-form-control textarea"
    );
    for (let i = 0; i < fields.length; i++) {
      var field = fields[i];
      field.addEventListener("change", handleInputChange);
      if (field.nodeName === "INPUT") {
        field.addEventListener("focus", toggleInputFocus("focus"));
        field.addEventListener("blur", toggleInputFocus("blur"));
      }
    }

    var validate = function () {
      var valid = true;
      for (let i = 0; i < fields.length; i++) {
        var validField = validateField(fields[i]);
        if (!validField) valid = false;
      }
      return valid;
    };

    var atcButton = document.querySelector("[name=add]");
    if (atcButton) {
      atcButton.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          var valid = validate();
          if (valid) {
            var datepicker = document.querySelector('#delivery-date');
            if (!datepicker.value) GiftHeroAPI.setDeliveryDate(new Date());
            var quantityInput = document.querySelector("[name=quantity]");
            var quantity = quantityInput ? quantityInput.value : 1;
            GiftHeroAPI.addToCart(quantity, true).then(function () {
              window.SLIDECART_UPDATE();
              history.pushState(
                {},
                "",
                window.location.href + "?sideDrawer=true"
              );
            });
          }
        },
        { capture: true }
      );
    }
  });
})();
